import type { CuratorCardStudent } from '@/api/curatorCard';
import type { SubtypeAvailable } from '@/api/curatorSubtypes';

import { matchesSearch } from './search';

/**
 * Карточка куратора: поиск и порядок в длинных блоках (28.09.2026, вторая волна админки п. 8).
 *
 * Подтипов на проде — десятки, учеников у куратора — до сотни: без поиска нужное приходилось искать глазами по всей
 * странице. Всё здесь — на клиенте: оба списка приходят целиком.
 */

/**
 * Подтипы для показа: подходящие под запрос (по подтипу и названиям его курсов), отмеченные у куратора — сверху.
 *
 * ⚠️ «Отмеченные» — по СОХРАНЁННОМУ набору, а не по черновику: иначе строка прыгала бы вверх прямо под мышью при
 * каждом клике. ⚠️ Фильтр только для показа: сохраняется весь черновик, в том числе скрытые поиском отметки
 * (PUT заменяет набор целиком — сторож `curatorSubtypesCard.test.ts`).
 */
export function visibleSubtypes(
  available: readonly SubtypeAvailable[],
  saved: readonly string[],
  query: string,
): SubtypeAvailable[] {
  const mine = new Set(saved);
  return available
    .filter((a) => matchesSearch([a.subtype, ...a.marathons.map((m) => m.title)], query))
    .map((a, i) => ({ a, i }))
    .sort((x, y) => Number(mine.has(y.a.subtype)) - Number(mine.has(x.a.subtype)) || x.i - y.i)
    .map((x) => x.a);
}

/**
 * Ученики куратора под запрос — по имени, почте, курсу и группе. Порядок — серверный: сначала те, у кого больше работ
 * на проверке, дальше по имени.
 */
export function filterCuratorStudents(students: readonly CuratorCardStudent[], query: string): CuratorCardStudent[] {
  return students.filter((s) =>
    matchesSearch(
      [s.full_name, s.email, ...s.enrollments.flatMap((e) => [e.marathon_title, e.group_name])],
      query,
    ),
  );
}
